import { useState } from 'react';

import { TabScreenWrapper } from '@components/General/TabScreen';
import { Flap } from '@models/Flap';
import { Organization } from '@models/Organization';
import NotificacionesListScreen from './NotificacionesListScreen';
import PresenteeismFailuresScreen from './PresenteeismFailuresScreen';

interface NotificacionesScreenProps {
    org: Organization;
}

const NotificacionesScreen = ({org}) => {

    const [clickedScreen, setClickedScreen] = useState<string>('notifications')

    const flaps: Flap[] = [
        { 
            id: 'notifications', 
            label: 'Sistema'.localized(), 
            content: <NotificacionesListScreen orgID={org.id} /> 
        },
        {
            id: 'presenteeism-failures',
            label: 'Fallas de fichadas'.localized(),
            width: '220px',
            content: <PresenteeismFailuresScreen orgID={org.id} />
        },
    ];

    return (
        <TabScreenWrapper
            title="Notificaciones"
            subtitle="Notificaciones del sistema"
            flaps={flaps}
            flag={org.newFlags.DashboardNotification}
            clickedScreen={clickedScreen}
            setClickedScreen={setClickedScreen}
        />
    );
};

export default NotificacionesScreen
